import React, { useEffect, useState } from "react";
import {
  Upload,
  FileText,
  CheckCircle,
  XCircle,
  AlertCircle,
  Download,
  Target,
  TrendingUp,
  Award,
  Zap,
  Mail,
  Briefcase,
  User,
} from "lucide-react";
import Footer from "../component/Home/Footer";
import Header from "../component/Home/Header";
import axios from "../axios";
import { useLocation } from "react-router-dom";
import Lottie from "lottie-react";
import AiLottie from "../../public/robo-ats.json";
import AiLottie2 from "../../public/Ai_loading_model.json";
import "./atssecure.css";
import getPlatformInfo, { notifySuccess } from "../action/customFn";
import { AnimatePresence, motion } from "motion/react";
import { MdError } from "react-icons/md";
import SmallLoader from "../component/SmallLoader";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import ScrollDownJSON from "../../public/scroll-down.json";
import { Progress } from "antd";

const AtsSecure = () => {

  const location = useLocation();
  const userIpInfo = useSelector((state) => state.paymentData.userIpInfo);
  const [file, setFile] = useState(null);
  const [email, setEmail] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [showATSForm, setShowATSForm] = useState(false);
  const [atsUser, setAtsUser] = useState(null);
  console.log(atsUser)
  const handleNavLinkClick = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      // section.scrollIntoView({ behavior: "smooth" });
      const scrollOffset = 60;
      const topOffset =
        section.getBoundingClientRect().top + window.scrollY - scrollOffset;
      window.scrollTo({ top: topOffset, behavior: "smooth" });
    }
  };

  async function checkValidUser() {
    try {
      const atsUserLS = JSON.parse(localStorage.getItem("atsuser"));
      if (!atsUserLS) setShowATSForm(false);
      else {
        const targetEmail = atsUserLS.email;
        const response = await axios.post("/ats/create-user-verify", { email: targetEmail });
        if (response.status === 200) {
          setShowATSForm(true);
          console.log("Verifying the users ats data from LS",response);
          setAtsUser(response.data.atsData);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    checkValidUser();
  }, [])

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    const files = e.dataTransfer.files;
    if (files && files[0]) {
      handleFile(files[0]);
    }
  };

  const handleFileInput = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      handleFile(selectedFile);
    }
  };

  const handleFile = (selectedFile) => {
    // Check file type
    const allowedTypes = ["application/pdf"];

    if (!allowedTypes.includes(selectedFile.type)) {
      alert("Please upload a PDF file");
      return;
    }

    setFile(selectedFile);
    // Clear file error when valid file is selected
    setFormErrors((prev) => ({ ...prev, file: null }));
  };

  const validateForm = () => {
    const errors = {};

    if (!file) {
      errors.file = "Please upload your resume";
    }

    if (!jobDescription.trim()) {
      errors.jobDescription = "Job description is required";
    } else if (jobDescription.trim().length < 50) {
      errors.jobDescription =
        "Job description should be at least 50 characters";
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const analyzeResume = async () => {
    try {
      if (!validateForm()) {
        return;
      }

      setLoading(true);
      // Simulate API call for ATS analysis
      const formData = new FormData();
      const email = JSON.parse(localStorage.getItem("atsuser")).email;
      formData.append("email", email);
      formData.append("jobDescription", jobDescription);
      formData.append("file", file);

      const url = "/ats/check-score";
      const response = await axios.post(url, formData);
      if (response.status === 200) {
        setResults(response.data?.result);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getScoreVariant = (score) => {
    if (score >= 90) return "success";
    if (score >= 80) return "primary";
    if (score >= 70) return "warning";
    return "danger";
  };

  const getScoreTextColor = (score) => {
    if (score >= 90) return "text-success";
    if (score >= 80) return "text-primary";
    if (score >= 70) return "text-warning";
    return "text-danger";
  };

  const getScoreGradient = (score) => {
    if (score >= 90) return "linear-gradient(135deg, #28a745 0%, #20c997 100%)";
    if (score >= 80) return "linear-gradient(135deg, #007bff 0%, #6f42c1 100%)";
    if (score >= 70) return "linear-gradient(135deg, #ffc107 0%, #fd7e14 100%)";
    return "linear-gradient(135deg, #dc3545 0%, #e83e8c 100%)";
  };

  const resetForm = () => {
    setFile(null);
    setEmail("");
    setJobDescription("");
    setResults(null);
    setFormErrors({});
  };

  return (
    <>
      <div className="animated-gradient" style={{ minHeight: "100vh" }}>
        <Header />
        {/* Hero Section */}
        <div className="hero-section" style={{ position: "relative" }}>
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                <div className="feature-icon" style={{ background: "none", boxShadow: "none", width: "15%", paddingTop: "30px" }}>
                  <Lottie onClick={() => { }} animationData={AiLottie} style={{ width: "100%" }} loop={true} />
                </div>
                <h1 style={{ fontSize: "52px", paddingTop: "25px" }} className="fw-bold text-white">
                  AI-Powered ATS Resume Analyzer
                </h1>
                <p
                  className="lead text-white mb-5"
                  style={{ fontSize: "1.3rem", paddingTop: "24px" }}
                >
                  Optimize your resume for Applicant Tracking Systems with our
                  advanced AI analysis. Get detailed insights and actionable
                  recommendations to boost your job application success rate.
                </p>

                {/* Feature highlights */}
                <div className="row" style={{ paddingTop: "50px" }}>
                  <div className="col-md-4 mb-4">
                    <div className="text-center">
                      <TrendingUp size={40} className="text-white mb-3" />
                      <h5 className="text-white">98% Accuracy</h5>
                      <p className="text-white-50">
                        Industry-leading ATS compatibility scoring
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 mb-4">
                    <div className="text-center">
                      <Zap size={40} className="text-white mb-3" />
                      <h5 className="text-white">Instant Results</h5>
                      <p className="text-white-50">
                        Get comprehensive analysis in seconds
                      </p>
                    </div>
                  </div>
                  <div className="col-md-4 mb-4">
                    <div className="text-center">
                      <Award size={40} className="text-white mb-3" />
                      <h5 className="text-white">Expert Insights</h5>
                      <p className="text-white-50">
                        Professional recommendations from HR experts
                      </p>
                    </div>
                  </div>
                </div>
                <div style={{display:"flex", justifyContent:"center"}}>
                <Lottie className="xnmrph-lottie" onClick={()=>{ handleNavLinkClick("xnmrph-ats-formid") }} animationData={ScrollDownJSON} style={{width:"60px", cursor:"pointer", transition:"all 300ms ease"}} loop={true} />
                </div>
              </div>
            </div>
          </div>
          {
            !showATSForm && <div className="ats-plans-modal">
              <div className="ats-plans-content">
                <div className="authroot-form-wr" style={{ width: "55%", minHeight: "auto" }}>
                  <Formik
                    initialValues={{ email: "", password: "" }}
                    validate={(values) => {
                      const errors = {};
                      if (!values.email) {
                        errors.email = "Email is Required";
                      } else if (
                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                      ) {
                        errors.email = "Invalid email address";
                      }
                      if (!values.password) {
                        errors.password = "Password is Required";
                      }
                      return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setStatus }) => {
                      try {
                        const url = "/ats/user-login";
                        const postData = {
                          email: values.email.toLocaleLowerCase(),
                          password: values.password,
                          deviceInfo: getPlatformInfo(),
                          userIpInfo: userIpInfo.ip,
                        };
                        const res = await axios.post(url, postData);
                        if(res.status === 200) {
                          const { message, atsData } = res.data;
                          notifySuccess("ATS Logged In");
                          setSubmitting(false);
                          localStorage.setItem("atsuser", JSON.stringify(atsData));
                          setShowATSForm(true);
                          setAtsUser(atsData);
                        }

                      } catch (error) {
                        console.log(error);
                        setStatus({
                          error: true,
                          message: error.response?.data?.message,
                        });
                        if (error instanceof AxiosError) {
                          if (error.response?.status === 419) {

                          }
                        }
                      }
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      status,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <h5 style={{ fontSize: "28px", color:"#000", fontWeight:"700", marginBlockEnd:"0px" }}>
                          Sign In
                        </h5>
                        <AnimatePresence>
                          {(status?.error) && (
                            <motion.div
                              initial={{ height: 0, opacity: 0 }}
                              animate={{ height: "auto", opacity: 1 }}
                              exit={{ height: 0, opacity: 0 }}
                              className="error-holder"
                            >
                              <div style={{ width: "20px", fontSize: "20px" }}>
                                <MdError />
                              </div>
                              <span>{status?.message}</span>
                            </motion.div>
                          )}
                        </AnimatePresence>
                        {!status && <div style={{ marginTop: "20px" }}></div>}
                        <AnimatePresence>
                          {errors.email && touched.email && (
                            <motion.div
                              key={"email_error_msg"}
                              style={{
                                margin: "0px",
                                marginBottom: "-10px",
                                color: "#d3351a",
                                fontWeight: "600",
                                fontSize: "13px",
                              }}
                              initial={{ opacity: 0, height: 0 }}
                              exit={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: "auto" }}
                            >
                              {errors.email && touched.email && errors.email}
                            </motion.div>
                          )}
                        </AnimatePresence>
                        <div style={{ position: "relative", width: "85%" }}>
                          <input
                            id="login__email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="email"
                            name="email"
                            placeholder="Email"
                            style={
                              errors.email && touched.email
                                ? { border: "2px solid #d3351a", width: "100%" }
                                : { width: "100%" }
                            }
                          />
                          {errors.email && touched.email && (
                            <MdError
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "20px",
                                color: "#d3351a",
                              }}
                            />
                          )}
                        </div>
                        <AnimatePresence>
                          {errors.password && touched.password && (
                            <motion.div
                              key={"password_error_msg"}
                              style={{
                                margin: "0px",
                                marginBottom: "-10px",
                                color: "#d3351a",
                                fontWeight: "600",
                                fontSize: "13px",
                              }}
                              initial={{ opacity: 0, height: 0 }}
                              exit={{ opacity: 0, height: 0 }}
                              animate={{ opacity: 1, height: "auto" }}
                            >
                              {errors.password && touched.password && errors.password}
                            </motion.div>
                          )}
                        </AnimatePresence>
                        <div style={{ position: "relative", width: "85%" }}>
                          <input
                            id="login__password"
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            type="password"
                            name="password"
                            placeholder="Password"
                            style={
                              errors.password && touched.password
                                ? { border: "2px solid #d3351a", width: "100%" }
                                : { width: "100%" }
                            }
                          />
                          {errors.password && touched.password && (
                            <MdError
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: "20px",
                                color: "#d3351a",
                              }}
                            />
                          )}
                        </div>
                        <button style={{ width: "85%" }} disabled={isSubmitting} className="submit" type="submit">
                          {isSubmitting ? <SmallLoader color={"#ffff"} /> : "Sign in"}
                        </button>
                      </form>
                    )}
                  </Formik>
                </div>
                <div
                  style={{
                    padding: "24px",
                    background: "#fff",
                    color: "#000",
                    borderRadius: "12px",
                    width: "45%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Lottie className="xnmrph-lottie" onClick={() => { handleNavLinkClick("homecount-xnmrph") }} animationData={AiLottie2} style={{ width: "100%", cursor: "pointer", transition: "all 300ms ease" }} loop={true} />
                  <h5>Log In to ATS Analyzer</h5>
                </div>
              </div>
            </div>
          }
        </div>

        {showATSForm && <div id="xnmrph-ats-formid" className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {/* Upload and Form Section */}
              <div className="premium-card rounded-4 mb-5">
                <div className="card-body p-5">
                  <div style={{display:"flex", alignItems:"center", justifyContent:"space-between", paddingBlockEnd:"30px"}}>
                    <p style={{color:"#000", textTransform:"capitalize", marginBlockEnd:"0px"}}>{atsUser?.tier}</p>
                    <Progress style={{width:"200px"}} percent={atsUser?.usageTracking?.percentageUsage || 0} status="active" />
                  </div>
                  <div className="text-center mb-4">
                    <h2 className="h3 fw-bold text-dark mb-2">
                      Upload Your Resume & Job Details
                    </h2>
                    <p className="text-muted">
                      Let our AI analyze your resume for ATS compatibility based
                      on your target job
                    </p>
                  </div>

                  {/* Email Input */}
                  {/* <div className="mb-4">
                    <label
                      htmlFor="email"
                      className="form-label fw-bold text-dark"
                    >
                      <Mail size={18} className="me-2" />
                      Email Address
                    </label>
                    <input
                      type="email"
                      className={`form-control form-control-lg ${formErrors.email ? "is-invalid" : ""
                        }`}
                      id="email"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        if (formErrors.email) {
                          setFormErrors((prev) => ({ ...prev, email: null }));
                        }
                      }}
                    />
                    {formErrors.email && (
                      <div className="invalid-feedback">{formErrors.email}</div>
                    )}
                  </div> */}

                  {/* Job Description Input */}
                  <div className="mb-4">
                    <label
                      htmlFor="jobDescription"
                      className="form-label fw-bold text-dark"
                    >
                      <Briefcase size={18} className="me-2" />
                      Job Description
                    </label>
                    <textarea
                      className={`form-control form-control-lg ${formErrors.jobDescription ? "is-invalid" : ""
                        }`}
                      id="jobDescription"
                      rows="6"
                      placeholder="Paste the complete job description here. Include requirements, responsibilities, and preferred qualifications..."
                      value={jobDescription}
                      onChange={(e) => {
                        setJobDescription(e.target.value);
                        if (formErrors.jobDescription) {
                          setFormErrors((prev) => ({
                            ...prev,
                            jobDescription: null,
                          }));
                        }
                      }}
                    />
                    {formErrors.jobDescription && (
                      <div className="invalid-feedback">
                        {formErrors.jobDescription}
                      </div>
                    )}
                    <div className="form-text">
                      {jobDescription.length}/50 characters minimum
                    </div>
                  </div>

                  {/* File Upload */}
                  <div className="mb-4">
                    <label className="form-label fw-bold text-dark">
                      <Upload size={18} className="me-2" />
                      Resume File
                    </label>
                    <div
                      className={`upload-zone rounded-4 p-4 text-center ${dragActive ? "active" : ""
                        } ${formErrors.file ? "border-danger" : ""}`}
                      onDragEnter={handleDrag}
                      onDragLeave={handleDrag}
                      onDragOver={handleDrag}
                      onDrop={handleDrop}
                    >
                      <Upload className="mx-auto mb-3 text-muted" size={48} />
                      <h4 className="h5 mb-3 text-dark">
                        Drop your resume here
                      </h4>
                      <p className="text-muted mb-3">
                        or click to browse from your device
                      </p>
                      <p className="small text-muted mb-4">
                        Supports PDF • Maximum 10MB
                      </p>

                      <input
                        type="file"
                        id="resume-upload"
                        className="d-none"
                        accept=".pdf"
                        onChange={handleFileInput}
                      />

                      <label
                        htmlFor="resume-upload"
                        className="neo-xnmrph-btn-blue btn-lg"
                        style={{ cursor: "pointer" }}
                      >
                        <Upload size={20} className="me-2" />
                        Choose File
                      </label>
                    </div>
                    {formErrors.file && (
                      <div className="text-danger mt-2">
                        <small>{formErrors.file}</small>
                      </div>
                    )}
                  </div>

                  {file && (
                    <div className="mb-4 premium-card rounded-3 p-3">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <div
                            className="feature-icon"
                            style={{
                              width: "50px",
                              height: "50px",
                              marginRight: "15px",
                            }}
                          >
                            <FileText size={20} color="white" />
                          </div>
                          <div>
                            <h6 className="mb-0 fw-bold text-dark">
                              {file.name}
                            </h6>
                            <p className="small text-muted mb-0">
                              {(file.size / 1024 / 1024).toFixed(2)} MB
                            </p>
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            setFile(null);
                            setFormErrors((prev) => ({ ...prev, file: null }));
                          }}
                          className="btn btn-outline-danger btn-sm"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Analyze Button */}
                  <div className="text-center">
                    <button
                      onClick={analyzeResume}
                      disabled={loading}
                      className={`ats-sec-btn2 ${loading ? "btn-secondary" : "neo-xnmrph-btn-orange"
                        }`}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Analyzing Resume...
                        </>
                      ) : (
                        <>
                          <Target size={20} className="me-2" />
                          Analyze Resume for This Job
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>

              {/* Results Section */}
              {results && (
                <div className="premium-card rounded-4">
                  <div className="card-body p-5">
                    <div className="text-center mb-5">
                      <h2 className="h3 fw-bold text-dark mb-2">
                        ATS Analysis Results
                      </h2>
                      <div className="glass-effect rounded-3 p-3 mb-4">
                        <div className="d-flex align-items-center justify-content-center flex-wrap gap-3">
                          <div className="d-flex align-items-center">
                            <User size={18} className="text-primary me-2" />
                            <small className="text-muted">
                              Analyzed for: {results.userEmail}
                            </small>
                          </div>
                          <div className="d-flex align-items-center">
                            <Briefcase size={18} className="text-info me-2" />
                            <small className="text-muted">
                              Target Role: {results.jobTitle}
                            </small>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-center mb-4">
                        <div
                          className="score-circle"
                          style={{
                            background: getScoreGradient(results.overallScore),
                          }}
                        >
                          {results.overallScore}/100
                        </div>
                      </div>
                      <h4
                        className={`fw-bold ${getScoreTextColor(
                          results.overallScore
                        )}`}
                      >
                        {results.overallScore >= 90
                          ? "Excellent Match!"
                          : results.overallScore >= 80
                            ? "Good Match!"
                            : results.overallScore >= 70
                              ? "Needs Improvement"
                              : "Poor Match"}
                      </h4>
                      <p className="text-muted">
                        {results.overallScore >= 90
                          ? "Your resume is highly optimized for this job and ATS systems"
                          : results.overallScore >= 80
                            ? "Your resume performs well for this job posting"
                            : results.overallScore >= 70
                              ? "Your resume needs optimization for this specific job"
                              : "Your resume requires significant improvements for this job"}
                      </p>
                    </div>

                    {/* Keyword Analysis */}
                    <div className="glass-effect rounded-3 p-4 mb-4">
                      <h5 className="fw-bold text-dark mb-3">
                        <Target className="me-2" size={20} />
                        Keyword Analysis
                      </h5>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <h6 className="fw-bold text-success mb-2">
                            Matched Keywords
                          </h6>
                          <div>
                            {results.matchedKeywords.map((keyword, index) => (
                              <span key={index} className="keyword-badge">
                                {keyword}
                              </span>
                            ))}
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <h6 className="fw-bold text-warning mb-2">
                            Missing Keywords
                          </h6>
                          <div>
                            {results.missingKeywords.map((keyword, index) => (
                              <span
                                key={index}
                                className="missing-keyword-badge"
                              >
                                {keyword}
                              </span>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Score Breakdown */}
                    <div className="row mb-5">
                      {Object.entries(results.sections).map(
                        ([section, data]) => (
                          <div key={section} className="col-md-6 mb-4">
                            <div className="section-card rounded-3 h-100 p-4">
                              <div className="d-flex align-items-center justify-content-between mb-3">
                                <h5 className="fw-bold text-capitalize mb-0 text-dark">
                                  {section === "jobMatch"
                                    ? "Job Match"
                                    : section.replace(/([A-Z])/g, " $1").trim()}
                                </h5>
                                <div
                                  className="score-circle"
                                  style={{
                                    background: getScoreGradient(data.score),
                                    width: "50px",
                                    height: "50px",
                                    fontSize: "0.9rem",
                                  }}
                                >
                                  {data.score}
                                </div>
                              </div>

                              <div className="mb-3">
                                {data.passed.map((item, index) => (
                                  <div
                                    key={index}
                                    className="d-flex align-items-start mb-2"
                                  >
                                    <CheckCircle
                                      className="text-success me-2 mt-1 flex-shrink-0"
                                      size={16}
                                    />
                                    <small className="text-muted">{item}</small>
                                  </div>
                                ))}

                                {data.issues.map((item, index) => (
                                  <div
                                    key={index}
                                    className="d-flex align-items-start mb-2"
                                  >
                                    <XCircle
                                      className="text-danger me-2 mt-1 flex-shrink-0"
                                      size={16}
                                    />
                                    <small className="text-muted">{item}</small>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </div>

                    {/* Recommendations */}
                    <div className="glass-effect rounded-3 p-4 mb-4">
                      <div className="d-flex align-items-center mb-4">
                        <AlertCircle className="text-info me-3" size={28} />
                        <h4 className="fw-bold mb-0 text-dark">
                          Personalized Recommendations
                        </h4>
                      </div>
                      <div className="row">
                        {results.recommendations.map((rec, index) => (
                          <div key={index} className="col-md-6 mb-3">
                            <div className="recommendation-item">
                              <div className="d-flex align-items-start">
                                <span className="badge bg-primary me-3 mt-1">
                                  {index + 1}
                                </span>
                                <span className="text-dark fw-medium">
                                  {rec}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Action Buttons */}
                    <div className="text-center">
                      <div className="d-flex flex-wrap justify-content-center gap-3">
                        <button className="neo-xnmrph-btn-blue btn-lg">
                          <Download className="me-2" size={20} />
                          Download Detailed Report
                        </button>
                        <button className="neo-xnmrph-btn-blue btn-lg">
                          <Mail className="me-2" size={20} />
                          Email Results to {results.userEmail}
                        </button>
                        <button
                          onClick={resetForm}
                          className="btn btn-outline-secondary btn-lg"
                          style={{ borderRadius: "50px" }}
                        >
                          <Upload className="me-2" size={20} />
                          Analyze Another Resume
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>}
      </div>
    </>
  );
};

export default AtsSecure;
